export class MeterTypesFilter {
  name: string;
  meterTypes: Array<MeterTypes>;
  isVisible: boolean;

  constructor(_name: string, _meterTypes: Array<MeterTypes>, _isVisible: boolean) {
    this.name = _name;
    this.meterTypes = _meterTypes;
    this.isVisible = _isVisible;
  }

  isOn(): boolean {
    return this.meterTypes.every((x) => x.on);
  }
}

export interface MeterTypes {
  name: string;
  icon: string;
  on: boolean;
  isVisible: boolean;
}
